module.exports = __webpack_public_path__ + "img/Calendar_Xsmall_Button-inactive-dark.f78062b4.svg";